<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" text="Chi tiết hồ sơ" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="detailsFile"/>
            </vx-tooltip>
        </div>

        <vs-popup title="Chi tiết hồ sơ" :active.sync="popupShowDetailsFileFee" v-if="popupShowDetailsFileFee"
                  id="details_file_fee">
            <div class="vx-card" style="min-height: 170px">
                <div class="vx-row">
                    <div class="vx-col w-1/4 py-6 pl-8 info_file_fee">
                        <div class="vx-row mt-4">
                            <div class="vx-col w-full mb-2">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Khách hàng:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                    <span
                                        class="text-md font-semibold">{{ infoFileData.loyaltyCustomer.fullName }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Trạng thái (KH):</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <vs-chip class="ag-grid-cell-chip"
                                                 :color="chipColorType(infoFileData.customerType)">
                                        <span
                                            class="text-md font-semibold">{{
                                                checkStatusType(infoFileData.customerType)
                                            }}</span>
                                        </vs-chip>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2" v-if="infoFileData.dateAdmissionStr">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Ngày vào viện:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <span class="text-md">{{ infoFileData.dateAdmissionStr }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2" v-if="infoFileData.diagnostic">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Chẩn đoán:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <span class="text-md">{{ infoFileData.diagnostic }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2" v-if="infoFileData.conclude">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Kết luận:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <span class="text-md">{{ infoFileData.conclude }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2" v-if="infoFileData.consultant">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Tư vấn:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <span class="text-md">{{ infoFileData.consultant.fullName }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2" v-if="infoFileData.doctor">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Bác sĩ:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <span class="text-md">{{ infoFileData.doctor.fullName }}</span>
                                    </div>
                                </div>
                            </div>
<!--                            <div class="vx-col w-full mb-2" v-if="infoFileData.note">-->
<!--                                <div class="vx-row">-->
<!--                                    <div class="vx-col lg:w-1/3 w-full">-->
<!--                                        <span class="text-md font-semibold">Ghi chú:</span>-->
<!--                                    </div>-->
<!--                                    <div class="vx-col lg:w-2/3 w-full">-->
<!--                                        <span class="text-md">{{ infoFileData.note }}</span>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
                        </div>
                    </div>
                    <div class="vx-col w-3/4 py-6 pl-8">
                        <div class="vx-row">
                            <div class="vx-col w-full">
                                <vs-input icon-no-border icon="icon-search" icon-pack="feather"
                                          class="w-full input-rounded-full pr-8"
                                          placeholder="Tìm phiếu theo mã phiếu ..." v-model="keySearch"
                                          @input="searchMedical"/>
                            </div>
                        </div>
<!--                        <VuePerfectScrollbar ref="scrollDialog"-->
<!--                                             class="scroll-area&#45;&#45;nofications-dropdown size-content vx-row mt-6"-->
<!--                                             :settings="settings"-->
<!--                                             style="max-height: 70vh">-->
<!--                            <div class="vx-col xl:w-1/3 md:w-1/2 w-full mb-6"-->
<!--                                 v-for="(item, index) in detailsMedicalDataSearch"-->
<!--                                 :key="index">-->
<!--                                <div class="medical-bill w-full" @click="showDetailsFile(item)">-->
<!--                                    <div class="vx-row m-4">-->
<!--                                        <div class="vx-col w-full">-->
<!--                                            <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="40px"-->
<!--                                                 viewBox="0 0 24 24" fill="none">-->
<!--                                                <path-->
<!--                                                    d="M21.9199 16.7486C21.5899 19.4086 19.4099 21.5886 16.7499 21.9186C15.1399 22.1186 13.6399 21.6786 12.4699 20.8186C11.7999 20.3286 11.9599 19.2886 12.7599 19.0486C15.7699 18.1386 18.1399 15.7586 19.0599 12.7486C19.2999 11.9586 20.3399 11.7986 20.8299 12.4586C21.6799 13.6386 22.1199 15.1386 21.9199 16.7486Z"-->
<!--                                                    fill="#292D32"/>-->
<!--                                                <path-->
<!--                                                    d="M9.99 2C5.58 2 2 5.58 2 9.99C2 14.4 5.58 17.98 9.99 17.98C14.4 17.98 17.98 14.4 17.98 9.99C17.97 5.58 14.4 2 9.99 2ZM9.05 8.87L11.46 9.71C12.33 10.02 12.75 10.63 12.75 11.57C12.75 12.65 11.89 13.54 10.84 13.54H10.75V13.59C10.75 14 10.41 14.34 10 14.34C9.59 14.34 9.25 14 9.25 13.59V13.53C8.14 13.48 7.25 12.55 7.25 11.39C7.25 10.98 7.59 10.64 8 10.64C8.41 10.64 8.75 10.98 8.75 11.39C8.75 11.75 9.01 12.04 9.33 12.04H10.83C11.06 12.04 11.24 11.83 11.24 11.57C11.24 11.22 11.18 11.2 10.95 11.12L8.54 10.28C7.68 9.98 7.25 9.37 7.25 8.42C7.25 7.34 8.11 6.45 9.16 6.45H9.25V6.41C9.25 6 9.59 5.66 10 5.66C10.41 5.66 10.75 6 10.75 6.41V6.47C11.86 6.52 12.75 7.45 12.75 8.61C12.75 9.02 12.41 9.36 12 9.36C11.59 9.36 11.25 9.02 11.25 8.61C11.25 8.25 10.99 7.96 10.67 7.96H9.17C8.94 7.96 8.76 8.17 8.76 8.43C8.75 8.77 8.81 8.79 9.05 8.87Z"-->
<!--                                                    fill="#292D32"/>-->
<!--                                            </svg>-->
<!--                                        </div>-->
<!--                                        <div class="vx-col w-full mb-2">-->
<!--                                            <span>Mã phiếu thu: </span>-->
<!--                                            <span class="text-md font-semibold">{{ item.code }}</span>-->
<!--                                        </div>-->
<!--                                        <div class="vx-col w-full mb-2" v-if="item.beautyPackageCombo">-->
<!--                                            <span class="text-md font-semibold">Combo:</span>-->
<!--                                            <span class="text-md">-->
<!--                                                {{ item.beautyPackageCombo.code + '-' + item.beautyPackageCombo.name }}-->
<!--                                            </span>-->
<!--                                        </div>-->
<!--                                        <div class="vx-col w-full mb-2" v-if="item.beautyService">-->
<!--                                            <span class="text-md font-semibold">Nhóm dịch vụ:</span>-->
<!--                                            <span class="text-md">-->
<!--                                                {{ item.beautyService.code + '-' + item.beautyService.name }}-->
<!--                                            </span>-->
<!--                                        </div>-->
<!--                                        <div class="vx-col w-full mb-2" v-if="item.beautyServicePackage">-->
<!--                                            <span class="text-md font-semibold">Dịch vụ:</span>-->
<!--                                            <span class="text-md">-->
<!--                                                {{ item.beautyServicePackage.code + '-' + item.beautyServicePackage.name }}-->
<!--                                            </span>-->
<!--                                        </div>-->
<!--                                        <div class="vx-col w-full flex justify-center items-center gap-4 mb-2">-->
<!--                                            <span class="text-md font-semibold">Loại:</span>-->
<!--                                            <vs-chip class="ag-grid-cell-chip"-->
<!--                                                     :color="chipColorType(item.type)">-->
<!--                                        <span-->
<!--                                            class="text-md font-semibold">{{-->
<!--                                                checkStatusType(item.type)-->
<!--                                            }}</span>-->
<!--                                            </vs-chip>-->
<!--                                        </div>-->
<!--                                        <div class="vx-col w-full flex justify-center items-center gap-4">-->
<!--                                            <span class="text-md font-semibold">Trạng thái:</span>-->
<!--                                            <vs-chip class="ag-grid-cell-chip"-->
<!--                                                     :color="item.settingMedicalExaminationStep.medicalExaminationStep.color">-->
<!--                                            <span class="text-md font-semibold">-->
<!--                                                {{ item.settingMedicalExaminationStep.medicalExaminationStep.name }}-->
<!--                                            </span>-->
<!--                                            </vs-chip>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </VuePerfectScrollbar>-->
<!--                        <div class="vx-row" v-if="detailsMedicalDataSearch.length === 0">-->
<!--                            <div class="vx-col w-full">-->
<!--                                <span>Không có dữ liệu</span>-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="mt-6">
                            <vs-table stripe :data="detailsMedicalDataSearch" noDataText="Không có dữ liệu">
                                <template slot="thead">
                                    <vs-th>
                                        STT
                                    </vs-th>
                                    <vs-th>
                                        Mã phiếu thu
                                    </vs-th>
                                    <vs-th>
                                        Loại thu phí
                                    </vs-th>
                                    <vs-th>
                                        Combo
                                    </vs-th>
                                    <vs-th>
                                        Nhóm dịch vụ
                                    </vs-th>
                                    <vs-th>
                                        Dịch vụ
                                    </vs-th>
                                    <vs-th>
                                        Ngày thanh toán
                                    </vs-th>
                                    <vs-th>
                                        Tổng tiền (VND)
                                    </vs-th>
                                    <vs-th>
                                        Đã đóng (VND)
                                    </vs-th>
                                    <vs-th>
                                        Trạng thái
                                    </vs-th>
                                    <vs-th>
                                        Hành động
                                    </vs-th>
                                </template>

                                <template slot-scope="{data}">
                                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                                        <vs-td>
                                            {{indextr + 1}}
                                        </vs-td>
                                        <vs-td>
                                            <vx-tooltip class="position-icon" color="primary" :text="tr.code" position="top" v-if="tr.code">
                                                    <span class="whitespace-no-wrap overflow-hidden text-ellipsis block" style="width: 100px !important;">
                                                    {{tr.code}}
                                                </span>
                                            </vx-tooltip>
                                            <!--                                            {{tr.code}}-->
                                        </vs-td>
                                        <vs-td>
                                            <vs-chip class="ag-grid-cell-chip-fee"
                                                     :color="chipColorType(tr.type)">
                                                <span class="text-md font-semibold">
                                                    {{checkStatusType(tr.type)}}
                                                </span>
                                            </vs-chip>
                                        </vs-td>
                                        <vs-td>
                                            <vx-tooltip class="position-icon" color="primary" :text="tr.beautyPackageCombo.code + '-' + tr.beautyPackageCombo.name" position="top" v-if="tr.beautyPackageCombo">
                                                    <span class="whitespace-no-wrap overflow-hidden text-ellipsis block" style="width: 150px !important;">
                                                    {{tr.beautyPackageCombo.code + '-' + tr.beautyPackageCombo.name}}
                                                </span>
                                            </vx-tooltip>
                                        </vs-td>
                                        <vs-td>
                                            <vx-tooltip class="position-icon" color="primary" :text="tr.beautyService.code + '-' + tr.beautyService.name" position="top" v-if="tr.beautyService">
                                                    <span class="whitespace-no-wrap overflow-hidden text-ellipsis block" style="width: 150px !important;">
                                                    {{tr.beautyService.code + '-' + tr.beautyService.name}}
                                                </span>
                                            </vx-tooltip>
                                        </vs-td>
                                        <vs-td>
                                            <vx-tooltip class="position-icon" color="primary" :text="tr.beautyServicePackage.code + '-' + tr.beautyServicePackage.name" position="top" v-if="tr.beautyServicePackage">
                                                    <span class="whitespace-no-wrap overflow-hidden text-ellipsis block" style="width: 150px !important;">
                                                    {{tr.beautyServicePackage.code + '-' + tr.beautyServicePackage.name}}
                                                </span>
                                            </vx-tooltip>
                                        </vs-td>
                                        <vs-td>
                                            {{ tr.paymentDateStr }}
                                        </vs-td>
                                        <vs-td>
                                            {{ tr.total ? numberWithCommas(tr.total) : 0 }}
                                        </vs-td>
                                        <vs-td>
                                            {{ tr.amountPaid ? numberWithCommas(tr.amountPaid) : 0 }}
                                        </vs-td>
                                        <vs-td>
                                            <vs-chip class="ag-grid-cell-chip-fee"
                                                     :color="tr.settingMedicalExaminationStep.medicalExaminationStep.color">
                                                <span
                                                    class="text-md font-semibold">{{
                                                        tr.settingMedicalExaminationStep.medicalExaminationStep.name
                                                    }}
                                                </span>
                                            </vs-chip>
                                        </vs-td>
                                        <vs-td>
                                            <vx-tooltip class="position-icon" text="Chi tiết" position="top">
                                                <feather-icon icon="EyeIcon" class="action-success mt-3 text-success"
                                                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                                                              @click="showDetailsFile(tr)"/>
                                            </vx-tooltip>
                                        </vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>
                        </div>
                    </div>
                </div>
            </div>

            <vs-popup class="holamundo" id="details_file_popup"
                      :active.sync="isShowDetailsFile">
                <div class="vx-row">
                    <div class="vx-col w-full flex justify-between">
                        <h4>Chi tiết phiếu thu</h4>
                        <feather-icon icon="XIcon" class="hover:text-danger" svgClasses="h-5 w-5"
                                      @click="closeDetailsFile"/>
                    </div>
                </div>
                <vs-divider/>
                <div class="vx-row mt-6" v-if="feeReceiptInfo && feeReceiptInfo.code">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Mã phiếu thu:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                        <span class="text-md font-semibold text-primary">{{ feeReceiptInfo.code }}</span>
                    </div>
                </div>
                <div class="vx-row mt-6" v-if="feeReceiptInfo && feeReceiptInfo.type">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Loại:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                        <vs-chip class="ag-grid-cell-chip"
                                 :color="chipColorType(feeReceiptInfo.type)">
                                        <span
                                            class="text-md font-semibold">{{
                                                checkStatusType(feeReceiptInfo.type)
                                            }}</span>
                        </vs-chip>
                    </div>
                </div>
                <div class="vx-row mt-6" v-if="feeReceiptInfo">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Trạng thái:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                        <vs-chip class="ag-grid-cell-chip"
                                 :color="feeReceiptInfo.settingMedicalExaminationStep.medicalExaminationStep.color">
                        <span
                            class="text-md font-semibold">{{
                                feeReceiptInfo.settingMedicalExaminationStep.medicalExaminationStep.name
                            }}
                        </span>
                        </vs-chip>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="feeReceiptInfo && feeReceiptInfo.beautyPackageCombo">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Combo:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md">
                        {{ feeReceiptInfo.beautyPackageCombo.code + '-' + feeReceiptInfo.beautyPackageCombo.name }}
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="feeReceiptInfo && feeReceiptInfo.beautyService">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Nhóm dịch vụ:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md">
                        {{ feeReceiptInfo.beautyService.code + '-' + feeReceiptInfo.beautyService.name }}
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="feeReceiptInfo && feeReceiptInfo.beautyServicePackage">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Dịch vụ:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md">
                        {{ feeReceiptInfo.beautyServicePackage.code + '-' + feeReceiptInfo.beautyServicePackage.name }}
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="feeReceiptInfo && feeReceiptInfo.paymentDate">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Ngày đóng tiền:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md">
                        {{ feeReceiptInfo.paymentDate }}
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="feeReceiptInfo && feeReceiptInfo.total">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Tổng tiền:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md text-primary font-semibold">
                        {{ feeReceiptInfo.total }} VND
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="feeReceiptInfo && feeReceiptInfo.amountPaid">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Đã đóng:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md text-warning font-semibold">
                        {{ feeReceiptInfo.amountPaid }} VND
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="feeReceiptInfo && feeReceiptInfo.note">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Ghi chú:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md">
                        {{ feeReceiptInfo.note }}
                    </span>
                    </div>
                </div>
            </vs-popup>
        </vs-popup>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import {en, vi} from 'vuejs-datepicker/dist/locale'
import moment from "moment";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
    name: "CellRendererActionsFee",
    components: {
        flatPickr,
        vSelect,
        Datepicker,
        VuePerfectScrollbar
    },
    props: {
    rowData: {
      type: Object,
      required: true,
    },
  },
    data() {
        return {
            popupCreateFile: false,
            createdDate: new Date(),
            configDatePicker: {
                dateFormat: 'd-m-Y',
            },
            customerTypeOptions: [
                {value: 1, label: "Khách hàng cũ tới tái khám"},
                {value: 2, label: "Khách hàng cũ sử dụng dịch vụ"},
                {value: 3, label: "Khách hàng cũ tới tư vấn dv"},
                {value: 4, label: "Khách hàng mới đến tư vấn"},
                {value: 5, label: "Khách hàng tới mua thuốc mỹ phẩm"},
                {value: 6, label: "Khách hàng trả lại thuốc"},
                {value: 7, label: "Khách hàng tới hoàn phí"},
            ],
            selectedCustomerTypeValue: null,
            beautyBooking: null,
            healthInsuranceNum: null,
            reasonForExamination: null,
            noteReason: null,
            stepOptions: [
                {value: 1, label: 'Tiếp đón'},
                {value: 2, label: 'Tư vấn'},
                {value: 3, label: 'Thu phí'},
                {value: 4, label: 'Cận lâm sàng'},
                {value: 5, label: 'Hoàn thành'},
            ],
            selectedStepValue: null,
            employeeOptions: [],
            selectedEmployeeValue1: null,
            selectedEmployeeValue2: null,
            selectedDoctorValue: null,
            en: en,
            vi: vi,
            highlightedFn: {
                customPredictor(date) {
                    if (moment(new Date()).format('YYYY-MM-DD') == moment(new Date(date)).format('YYYY-MM-DD')) {
                        return true;
                    }
                }
            },
            disabledDates: {
                customPredictor(date) {
                    if (moment(date).isAfter(moment(), 'days')) {
                        return true;
                    }
                }
            },
            popupCreateFee: false,
            createdDateFee: new Date(),
            codeFee: null,
            totalFee: 0,
            amountPaid: 0,
            createdDatePayment: new Date(),
            payment: null,
            statusOptions: [],
            selectedStatusValue: null,
            typeFeeOptions: [
                {value: 1, label: 'Thu phí dịch vụ'},
                {value: 2, label: 'Thu phí combo'},
                {value: 3, label: 'Thu phí thuốc'},
                {value: 4, label: 'Công nợ'},
                {value: 5, label: 'Tạm ứng'},
            ],
            selectedTypeFeeValue: null,
            selectedDoctorFeeValue: null,
            selectedNurseValue: null,
            selectBeautyServiceValue: null,
            beautyServiceData: [],
            beautyServicePackageOptions: [],
            selectBeautyServicePackage: null,
            beautyComboService: [],
            selectedComboServiceValue: null,
            boarding: false,

            popupShowDetailsFileFee: false,
            keySearch: null,
            settings: {
                wheelSpeed: 0.3,
                suppressScrollX: true,
            },
            isShowDetailsFile: false,
            infoFileData: [],
            detailsMedicalData: [],
            detailsMedicalDataSearch: [],
            feeReceiptInfo: null,
        }
    },

    computed: {
        //     selectedTypeFee: {
        //         get() {
        //             let obj = this.typeFeeOptions.find(x => x.value === this.selectedTypeFeeValue);
        //             if (!obj) return;
        //             return {
        //                 value: obj.value,
        //                 label: obj.label
        //             }
        //         },
        //         async set(obj) {
        //             this.selectedTypeFeeValue = obj ? obj.value : null;
        //             if (this.selectedTypeFeeValue === 1) await this.getBeautyService();
        //             if (this.selectedTypeFeeValue === 2) await this.getBeautyComboService();
        //         }
        //     },
        //
        //     selectBeautyService: {
        //         get() {
        //             let obj = this.beautyServiceData.find(x => x.value === this.selectBeautyServiceValue);
        //             if (!obj) return;
        //             return {
        //                 value: obj.value,
        //                 label: obj.label
        //             }
        //         },
        //         set(obj) {
        //             this.selectBeautyServiceValue = obj ? obj.value : null;
        //             this.getBeautyServicePack();
        //         }
        //     },
        chipColorType() {
            return value => {
                if (value === 1) {
                    return "primary";
                } else if (value === 2) {
                    return 'warning'
                } else if (value === 3) {
                    return 'success'
                } else if (value === 4) {
                    return 'danger'
                } else if (value === 5) {
                    return 'primary'
                }
            }
        },
        checkStatusType() {
            return value => {
                if (value === 1) {
                    return "Thu phí dịch vụ";
                } else if (value === 2) {
                    return "Thu phí combo"
                } else if (value === 3) {
                    return "Thu phí thuốc"
                } else if (value === 4) {
                    return "Công nợ"
                } else if (value === 5) {
                    return "Tạm ứng"
                }
            }
        },
    },

    methods: {
        detailsFile() {
            this.infoFileData = this.rowData;
            this.infoFileData.dateAdmissionStr = this.infoFileData.dateAdmission ? moment(this.infoFileData.dateAdmission).format('DD/MM/YYYY') : null;
            this.detailsMedicalData = this.infoFileData.beautyCollectFees.map(el => {
                el.paymentDate = el.paymentDate ? el.paymentDate.replace('+0000', 'Z') : null
                el.paymentDateStr = el.paymentDate ? moment(el.paymentDate).format('DD/MM/YYYY HH:mm:ss') : null
                return el
            })
            this.detailsMedicalDataSearch = this.detailsMedicalData;
            this.popupShowDetailsFileFee = true;
        },

        showDetailsFile(data) {
            this.feeReceiptInfo = null;
            this.feeReceiptInfo = data;
            this.feeReceiptInfo.paymentDate = data.paymentDate ? (data.paymentDate.includes('/') ? data.paymentDate : moment(data.paymentDate).format('DD/MM/YYYY HH:mm:ss')) : null;
            this.feeReceiptInfo.total = data.total ? this.numberWithCommas(data.total) : null;
            this.feeReceiptInfo.amountPaid = data.amountPaid ? this.numberWithCommas(data.amountPaid) : null;
            setTimeout(() => {
                this.isShowDetailsFile = true
            }, 100)
        },

        closeDetailsFile() {
            this.isShowDetailsFile = false;
        },

        searchMedical(event) {
            let str = event.toLowerCase();
            this.detailsMedicalDataSearch = this.detailsMedicalData.filter(el => el.code.toLowerCase().includes(str))
        },

        numberWithCommas(x) {
            x = x.toString();
            let pattern = /(-?\d+)(\d{3})/;
            while (pattern.test(x))
                x = x.replace(pattern, "$1,$2");
            return x;
        }
    }
}
</script>

<style lang="scss">
#details_file_fee {
    min-height: 170px;

    .medical-bill {
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: center;
        border: 1px solid #dbdade;
        border-radius: 0.375rem;
        min-height: 150px;
        cursor: pointer;
    }

    .medical-bill:hover {
        color: rgba(var(--vs-primary), 1);
        border: 1px solid rgba(var(--vs-primary), 1);

        svg path {
            fill: rgba(var(--vs-primary), 1);
        }
    }

    .info_file_fee {
        border-right: 1px solid #dbdade;
    }

    .vs-popup {
        width: 100% !important;
    }
}

#details_file_popup {
    .vs-popup--header {
        display: none;
    }

}

.ag-grid-cell-chip-fee {
    &.vs-chip-success {
        background: rgba(var(--vs-success), .15);
        color: rgba(var(--vs-success), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-warning {
        background: rgba(var(--vs-warning), .15);
        color: rgba(var(--vs-warning), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-danger {
        background: rgba(var(--vs-danger), .15);
        color: rgba(var(--vs-danger), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-cancel {
        background: rgba(var(--vs-cancel), .15);
        color: rgba(var(--vs-cancel), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-primary {
        background: rgba(var(--vs-primary), .15);
        color: rgba(var(--vs-primary), 1) !important;
        font-weight: 500;
    }
}
</style>
